module.exports = __webpack_public_path__ + "img/new_footer_logo.00489582.png";